import { useTellescopeMutation, useTellescopeQuery } from "@tellescope/tanstack-query";
import { EditablePersonCell } from "./EditablePersonCell";
import { useCallback } from "react";
import { PersonCell } from "./PersonCell";
import { useShallowSidebarStore } from "../../../store/sidebar-store";

export interface EnduserCellProps {
  enduserId?: string;
  ticketId: string;
  avatarOnly?: boolean;
  variant?: "editable" | "open-in-sidebar";
}

export const EnduserCell = ({ enduserId, ticketId, avatarOnly, variant = "editable" }: EnduserCellProps) => {
  const { openSidebar } = useShallowSidebarStore("openSidebar");
  const updateTicketMutation = useTellescopeMutation({
    model: "tickets",
    method: "updateOne",
  });

  const onChange = useCallback(
    (enduserId: string | null) => {
      updateTicketMutation.mutateAsync({
        id: ticketId,
        enduserId: enduserId ?? "",
      });
    },
    [ticketId, updateTicketMutation]
  );

  const enduserQuery = useTellescopeQuery({
    model: "endusers",
    method: "getOne",
    request: enduserId ?? "",
    enabled: variant === "open-in-sidebar" && !!enduserId,
  });

  if (variant === "open-in-sidebar" && enduserQuery.data) {
    return (
      <PersonCell
        person={enduserQuery?.data}
        avatarOnly
        onClick={
          enduserId
            ? (e) => {
                e.stopPropagation();
                e.preventDefault();
                openSidebar("ContactDetails", { enduserId, selectedSection: "Information" });
              }
            : undefined
        }
      />
    );
  }

  return <EditablePersonCell mode="enduser" value={enduserId} onChange={onChange} avatarOnly={avatarOnly} />;
};
